import React from "react";
import { Text, TextInput, useTranslation } from "@familyzone/component-library";
import { FilteringSourceCriteria } from "../criteriaTypes";

export interface UserAgentCriteriaProps {
  criteria: FilteringSourceCriteria;
  disabled: boolean;
  onChange: (criteria: FilteringSourceCriteria) => void;
}

const UserAgentCriteria: React.FC<UserAgentCriteriaProps> = ({ criteria, disabled, onChange }) => {
  const { t } = useTranslation();

  if (Array.isArray(criteria.conditions)) {
    return <Text>{t("Invalid Criteria")}</Text>;
  }

  const handleChangeUserAgent = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...criteria,
      conditions: {
        expression: e.target.value,
      },
    });
  };

  return (
    <TextInput
      name="user agent"
      placeholder={t("User Agent Regex")}
      isDisabled={disabled}
      value={String(criteria.conditions.expression)}
      onChange={handleChangeUserAgent}
    />
  );
};

export default UserAgentCriteria;
